import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DataGridFilters } from "fe-shared/src/components/DataGrid/modules/types";
import { BusinessRole } from "fe-shared/src/types/domain";

const useQueryFilters = (
  setFilters: (v: React.SetStateAction<DataGridFilters>) => void,
  getFiltersParams: (
    s: string,
    businessRoleCode?: BusinessRole
  ) => DataGridFilters,
  businessRoleCode?: BusinessRole
) => {
  const { search, pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (search) {
      const filtersParams = getFiltersParams(search, businessRoleCode);

      if (Object.keys(filtersParams).length) {
        setFilters(filtersParams);

        history.replace(pathname);
      }
    }
  }, [
    history,
    pathname,
    search,
    setFilters,
    getFiltersParams,
    businessRoleCode,
  ]);
};

export default useQueryFilters;
